<!--
 *
 * Copyright © 2017 Easymeeting AS. All rights reserved.
 *
 * This software is produced by Easymeeting AS.
 * Unauthorized redistribution, reproduction, or usage of
 * this software in whole or in part without the express
 * written consent of Easymeeting AS is strictly prohibited.
-->
<template>
  <div
    v-show="isShowing"
    class="toast-container"
    :data-qa="dataQa"
  >
    <svg-icon
      v-if="iconLeft"
      class="left"
      :icon="iconLeft"
      :data-qa="`${dataQa}_left_icon`"
    />
    <span
      v-if="text"
      :data-qa="`${dataQa}_text`"
    >{{ text }}</span>
    <svg-icon
      v-if="iconRight"
      class="right"
      :icon="iconRight"
      :data-qa="`${dataQa}_right_icon`"
    />
    <div
      class="bg-blur"
      :data-qa="`${dataQa}_bg_blured`"
    />
  </div>
</template>

<script>
import toast from '@/app/components/toast';
export default {
  name: 'ToastMessage',
  extends: toast,
  props: {
    dataQa: {
      type: String,
      default: null
    }
  }
};
</script>

<style scoped>
</style>
